import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as fromPolicy from "../policy-store/";
import * as AppState from "../state";
import { featureKey, State } from "./account.reducer";

const selectFeatureState =
  createFeatureSelector<AppState.State, State>(featureKey);

export const selectAccounts = createSelector(
  selectFeatureState,
  (state) => state.accounts
);

export const selectActiveAccounts = createSelector(selectAccounts, (accounts) =>
  accounts.filter((x) => x.cancelled !== true)
);

export const selectAllAccountsPolicies = createSelector(
  selectAccounts,
  fromPolicy.selectors.selectPolicies,
  (accounts, policies) =>
    accounts.map((account) => {
      return {
        account,
        policies: policies.filter(
          (policy) => policy.accountNumber === account.accountNumber
        ),
      };
    })
);